import styles from "./notificationfilter.module.css";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

const NotificationFilter = ({ setFilterData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => {
                    return { ...prev, searchKey: e.target.value };
                })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Type"
                        onChange={(e) => {
                            setFilterData(prev => {
                                return { ...prev, type: e.target.value };
                            })
                        }}
                    >
                        <MenuItem value="all">All Type</MenuItem>
                        <MenuItem value="Email">Email</MenuItem>
                        <MenuItem value="SMS">SMS</MenuItem>
                    </Select>
                </FormControl>
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("emailnotification:update") > -1 && <Link to={`/notification/email-sms-notification/add`} className={`${styles.AddNoteBu}`}>
                <Plus /> <span>Notification</span>
            </Link>}
        </div>
    </div>)
}

export default NotificationFilter;